import { IColumn } from '@fluentui/react';
import { Item } from '@h2oai/ui-kit';

import {
  apiCalledStyles,
  chatStyles,
  collectionStyles,
  documentStyles,
  H2OGPTeColumns,
  H2OGPTeEntry,
  jobStyles,
  naStyles,
  otherStyles,
  rpcCalledStyles,
} from './H2OGPTe.utils';

export const h2ogpteColumns: IColumn[] = [
  {
    key: H2OGPTeColumns.Date,
    fieldName: H2OGPTeColumns.Date,
    name: 'Date',
    minWidth: 200,
  },
  {
    key: H2OGPTeColumns.Username,
    fieldName: H2OGPTeColumns.Username,
    name: 'Username',
    minWidth: 350,
  },
  {
    key: H2OGPTeColumns.Resource,
    fieldName: H2OGPTeColumns.Resource,
    name: 'Resource',
    minWidth: 200,
    onRender: (item: H2OGPTeEntry) => {
      const resource = item.resource;
      const eventStyles = {
        Chat: chatStyles,
        'API Called': apiCalledStyles,
        'RPC Called': rpcCalledStyles,
        Collection: collectionStyles,
        Job: jobStyles,
        Document: documentStyles,
        Other: otherStyles,
        'N/A': naStyles,
      };
      return (
        <div>
          <Item
            data={{
              id: '',
              title: resource,
            }}
            styles={eventStyles[resource] || {}}
            idField="id"
            labelField="title"
          />
        </div>
      );
    },
  },
  {
    key: H2OGPTeColumns.Action,
    fieldName: H2OGPTeColumns.Action,
    name: 'Action',
    minWidth: 350,
  },
  {
    key: H2OGPTeColumns.Count,
    fieldName: H2OGPTeColumns.Count,
    name: 'Count',
    minWidth: 200,
  },
];

export const getH2ogpteStatsTableColumns = (keyColumnName: string): IColumn[] => [
  {
    key: 'key',
    fieldName: 'key',
    name: keyColumnName,
    minWidth: 300,
  },
  {
    key: 'value',
    fieldName: 'value',
    name: 'Usage Count',
    minWidth: 300,
  },
];
